(function(){
'use strict';
console.log('[CN] theme.js v-VariantRemap-v10 loaded');

var PACK5_ID = '44844808077447';
var CN_VARIANT_MAP = {
  '44939910381703': { id: PACK5_ID, qty: 2 },
  '44939910414471': { id: PACK5_ID, qty: 3 }
};

function forceDefaultToPack5(){
  try {
    document.querySelectorAll('input[name="id"]').forEach(function(input){
      if (input.closest('#cn-easysell-trigger, #product-form-cn')) {
        if (input.value !== PACK5_ID) {
          input.value = PACK5_ID;
        }
      }
    });
    document.querySelectorAll('#cn-easysell-trigger input[name="quantity"], #product-form-cn input[name="quantity"]').forEach(function(input){
      if (input.value !== '1') input.value = '1';
    });
  } catch(e) {}
}

function remapVariant(variantId){
  var key = String(variantId);
  if (CN_VARIANT_MAP[key]) {
    return { id: CN_VARIANT_MAP[key].id, qty: CN_VARIANT_MAP[key].qty };
  }
  return { id: variantId, qty: 1 };
}

function isProductPage(){
  return window.location.pathname.indexOf('/products/') === 0;
}

async function clearAndAddAndOpen(rawVariantId){
  var mapped = remapVariant(rawVariantId);
  var variantId = mapped.id;
  var qty = mapped.qty;
  try {
    await fetch('/cart/clear.js', {method: 'POST'});
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
    });
    document.querySelectorAll('input[name="id"]').forEach(function(input){ input.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function(input){ input.value = qty; });
    try {
      if (window.easysellApp && window.easysellApp.$children && window.easysellApp.$children[0]) {
        var es = window.easysellApp.$children[0];
        if (typeof es.fetchCart === 'function') await es.fetchCart();
        if (typeof es.fetchCurrentProduct === 'function') await es.fetchCurrentProduct();
      }
    } catch(e) {}
    return openEasySellForm();
  } catch(err) { return false; }
}

function openEasySellForm(){
  try {
    if (window.easysellApp && window.easysellApp.$children && window.easysellApp.$children[0] && typeof window.easysellApp.$children[0].onStickyButtonClick === 'function') {
      window.easysellApp.$children[0].onStickyButtonClick();
      return true;
    }
  } catch(e) {}
  try { var modal = document.querySelector('#easysell-modal'); if (modal) { modal.style.display = 'block'; return true; } } catch(e) {}
  try { var nativeBtn = document.querySelector('#cn-easysell-trigger button, #AddToCart'); if (nativeBtn) { nativeBtn.click(); return true; } } catch(e) {}
  return false;
}

function waitAndOpen(rawVariantId, maxWait){
  maxWait = maxWait || 5000;
  var start = Date.now();
  function tryOpen(){
    if (window.easysellApp && window.easysellApp.$children && window.easysellApp.$children[0]) {
      clearAndAddAndOpen(rawVariantId);
      return;
    }
    if (Date.now() - start < maxWait) {
      setTimeout(tryOpen, 200);
    } else {
      var mapped = remapVariant(rawVariantId);
      window.location.href = '/products/chiffon-nickel?variant=' + mapped.id + '&quantity=' + mapped.qty + '&autoopen=1';
    }
  }
  tryOpen();
}

async function goCheckout(rawVariantId, btn){
  var originalHtml = btn ? btn.innerHTML : '';
  if(btn){btn.disabled=true; btn.innerHTML='<span>Ouverture...</span>';}
  if (window.easysellApp && window.easysellApp.$children && window.easysellApp.$children[0]) {
    var ok = await clearAndAddAndOpen(rawVariantId);
    if (ok) {
      setTimeout(function(){ if(btn){btn.disabled=false; btn.innerHTML=originalHtml;} }, 1500);
      return;
    }
  }
  if (window.EASYSELL_CONFIG || document.querySelector('#easysell-modal, #easysell')) {
    waitAndOpen(rawVariantId, 5000);
    setTimeout(function(){ if(btn){btn.disabled=false; btn.innerHTML=originalHtml;} }, 3000);
    return;
  }
  var mapped = remapVariant(rawVariantId);
  window.location.href = '/products/chiffon-nickel?variant=' + mapped.id + '&quantity=' + mapped.qty + '&autoopen=1';
}

function handleAutoOpen(){
  if (!isProductPage()) return;
  var params = new URLSearchParams(window.location.search);
  if (params.get('autoopen') === '1') {
    var variantId = params.get('variant');
    setTimeout(function(){ waitAndOpen(variantId, 8000); }, 600);
  }
}

try { fetch('/cart/clear.js', {method:'POST'}); } catch(e) {}

document.addEventListener('click', function(e){
  var orderBtn = e.target.closest('[data-cn-order]');
  if(orderBtn){
    e.preventDefault();
    e.stopPropagation();
    var vid = orderBtn.dataset.cnOrder;
    if(vid) goCheckout(vid, orderBtn);
  }
}, true);

document.addEventListener('click', function(e){
  var a = e.target.closest('a[href^="#"]');
  if(a){
    var href = a.getAttribute('href');
    if(href && href.length > 1){
      var target = document.querySelector(href);
      if(target){ e.preventDefault(); target.scrollIntoView({behavior:'smooth', block:'start'}); }
    }
  }
});

function init(){
  console.log('[CN] init v10');
  forceDefaultToPack5();
  setTimeout(forceDefaultToPack5, 500);
  setTimeout(forceDefaultToPack5, 1500);
  setTimeout(forceDefaultToPack5, 3000);
  handleAutoOpen();
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){e.target.classList.add('visible'); io.unobserve(e.target);} });
    }, {threshold:0.05, rootMargin:'0px 0px -50px 0px'});
    document.querySelectorAll('.cn-fade-in').forEach(function(el){io.observe(el);});
  }
  var sticky = document.querySelector('.cn-sticky');
  if(sticky){
    window.addEventListener('scroll', function(){
      if(window.scrollY > 500){sticky.classList.add('visible');}
      else{sticky.classList.remove('visible');}
    }, {passive:true});
  }
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', init);
}else{
  init();
}
})();
